<div [class]="'next-other-products next-other-products--theme-' + themeSuffix">
  <img class="next-other-products__top-background"
       [src]="themeConfig.topBackgroundImage"
       alt="">
  <div class="next-other-products__content">
    <div class="next-other-products__title"
         [innerHTML]="title | translate | safeHtml">
    </div>

    <div class="next-other-products__products main">

      <ng-container *ngFor="let product of products">
      <a *ngIf="!product.disabled"
         target="_blank"
         [href]="getProductUrl(product)"
         [ngClass]="{
          'next-other-product--new': product.newProduct,
          'next-other-product--inactive': !getProductUrl(product)
          }"
         class="next-other-product">
        <div *ngIf="product.newProduct"
             class="next-other-product__new-badge">
          {{ 'NEXT_OTHER_PRODUCTS.NEW' | translate }}
        </div>
        <div class="next-other-product__icon">
          <img [src]="product.icon" alt="">
        </div>
        <div class="next-other-product__name"
             [innerHTML]="product.name | translate | safeHtml"></div>
      </a>
      </ng-container>
    </div>
  </div>
</div>
